<script>
    import { slide } from 'svelte/transition'
    import { checkURIValidity } from '../../utils/helper.js'

    /**
     * Possible name props
     * Name
     * Terms of Service
     * Privacy Policy
     */

    let { edited = false, autofocus = false, id = '', name = '', value = $bindable(), placeholder = '', readonly = false } = $props()

    // TODO: Refactor needed here, calling checkURIValidity function twice (here and on page)
    const isValidURI = $derived(
        value &&
        ['Privacy Policy', 'Terms of Service'].includes(name) &&
        checkURIValidity(value)
    )
</script>

<div class="w-full flex flex-col">
    <label for={id} class="px-4 font-medium text-base">{name}</label>
    <div class="py-1.5 flex flex-col" class:bg-green-400={value && edited}>
        <!-- svelte-ignore a11y_autofocus -->
        <input
            {id}
            name={id}
            {autofocus}
            {placeholder}
            type="text"
            {readonly}
            bind:value
            class="h-9 px-3 ml-8 mr-4 rounded-md dark:placeholder-[#808080]/80 bg-white dark:bg-[#151515]"
        />

        {#if !value}
            <span
                data-test="error-text"
                class="px-8 mt-2 text-sm text-red-500"
                transition:slide>Name cannot be blank</span
            >
        {/if}
    </div>
</div>
